'use-client';
import classnames from 'clsx';
import * as React from 'react';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import semanticClassNames from '../../../Container.semanticClassNames';
import type {
  IContainerProps,
  IContainerImperativeActions,
} from '../../../Container.types';
import { ContainerLogic } from '../../shared/ContainerLogic';
import styles from './ScotchTopArea.scss';

const ScotchTopArea: React.ForwardRefRenderFunction<
  IContainerImperativeActions,
  IContainerProps
> = (props, ref) => {
  return (
    <ContainerLogic
      {...props}
      ref={ref}
      className={classnames(styles.root, props.className)}
      renderSlot={({ containerChildren }) => (
        <>
          <div
            className={classnames(
              styles.bg,
              formatClassNames(
                semanticClassNames.root,
                ...(props.customClassNames || []),
              ),
            )}
          />
          {containerChildren}
          <div className={styles.scotch} />
        </>
      )}
    />
  );
};

export default React.forwardRef(ScotchTopArea);
